import { render, staticRenderFns } from "./wisdom_subject.vue?vue&type=template&id=4f1ad0c1&scoped=true&"
import script from "./wisdom_subject.vue?vue&type=script&lang=js&"
export * from "./wisdom_subject.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_subject.vue?vue&type=style&index=0&id=4f1ad0c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ad0c1",
  null
  
)

export default component.exports